import { useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from 'uuid';

const usePaginationV2 = ({
    id,
    service,
    lazyInit = false,
    defaultSearchData = {},
    defaultOrderBy,
    takeAll = false,
    pageColumns = null,
}) => {


    const [inited, setInited] = useState(false);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [count, setCount] = useState(0);
    const [searchData, setSearchData] = useState(defaultSearchData);
    const [errors, setErrors] = useState(null);

    const [max, setMax] = useState(25);

    const [orderBy, setOrderBy] = useState(defaultOrderBy);

    const timeout = useRef();

    useEffect(() => {
        setPage(0);
    }, [service, searchData, orderBy]);

    const search = async (customSearchData) => {
        try {

            setLoading(true);

            const currentSearchData = customSearchData || searchData;

            const { resultObject, resultCount, pageCount } = await service.getPagination(
                page + 1,
                currentSearchData,
                max,
                orderBy,
                takeAll
            );
            setData(resultObject);
            setCount(resultCount);
            setErrors(null);
            setPageCount(Math.ceil(resultCount / pageCount) + 1);

        } catch (e) {
            setErrors(e)
            setData([]);
            setCount(0);
            setPageCount(0);
        }
        setInited(true);
        setLoading(false);
    };

    useEffect(() => {
        if ((!inited && lazyInit)) {
            return;
        }
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
        timeout.current = setTimeout(async () => {
            await search();
        }, 500);
    }, [searchData, page, orderBy, inited, lazyInit]);

    const reset = () => {
        setPage(0)
        setSearchData(defaultSearchData);
        setOrderBy(defaultOrderBy);
    }

    const download = async () => {

        const cSVList = pageColumns
            .filter(column => column.name && column.label) // Ensure both name and label are present
            .map(column => ({
                key: column.cSVColumn && String(column.cSVColumn).trim() !== ''
                    ? String(column.cSVColumn).trim()
                    : column.name,
                value: column.label
            }));


        const filename = `${uuidv4()}.csv`;
        await service.exportCsv(
            searchData,
            filename,
            orderBy,
            cSVList
        );
    }

    return {
        loading,
        data,
        setData,
        errors,
        page,
        pageCount,
        count,
        setPage,
        searchData,
        setSearchData,
        orderBy,
        max,
        setMax,
        setOrderBy,
        reset,
        search,
        service,
        setLoading,
        inited,
        download
    }
}

export default usePaginationV2;
